import React, { Component }  from 'react'
import { Segment, Table, Input, Label, Grid, Confirm } from 'semantic-ui-react'

import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import titleCase from 'title-case'

import PaginationTable from '../../components/PaginationTable/PaginationTable'

const _ = {
  sortBy: sortBy,
  find: find,
  groupBy: groupBy,
  isEmpty: isEmpty
}

const changeCase = {
    titleCase: titleCase
}

class SectionStudents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      searchKey: '',
      fields: ['name', 'actions'],
      activePageMale: 1,
      activePageFemale: 1,
      itemPerPage: 6,
      selectedIndex: 0,
      column: null,
      direction: null,
      open: false,
      studentName: '',
      id: '',
      sectionId: ''
    };
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handlePaginationChangeMale = this.handlePaginationChangeMale.bind(this);
    this.handlePaginationChangeFemale = this.handlePaginationChangeFemale.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  open = (studentName, id, sectionId) => this.setState({ open: true, studentName, id, sectionId })
  close = () => this.setState({ open: false })

  isSearched(searchKey) {
    return function(item) {
      return (
        !searchKey ||
        item.student.firstName.toLowerCase().includes(searchKey.toLowerCase()) ||
        item.student.lastName.toLowerCase().includes(searchKey.toLowerCase())
      );
    };
  }

  onSearchChange(event) {
    this.setState({ searchKey: event.target.value });
  }

  handleSort(clickedColumn) {
    const { column, data, direction } = this.state
    if (column !== clickedColumn) {
      if (clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          data: _.sortBy(data, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }

    }
    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handlePaginationChangeMale(e, {activePage}){
    this.setState({
      activePageMale: activePage,
    });
  }

  handlePaginationChangeFemale(e, {activePage}){
    this.setState({
      activePageFemale: activePage,
    });
  }

  handleDelete() {
    this.props.handleDeleteSectionStudent(this.state.id, this.state.sectionId)
    this.setState({ open: false })
  }

  componentDidMount() {
    this.setState({data: this.props.sectionStudents})
  }

  componentWillReceiveProps(newProps) {
    this.setState({data: newProps.sectionStudents}, () => this.handleSort('name'))
  }

  render() {
    const { activePageMale, activePageFemale, itemPerPage, column, direction, data, searchKey, fields } = this.state;
    if(_.isEmpty(data)) return null;

    const gender = _.groupBy(data, o => o.student.gender)
    let currentDataMale = [], currentDataFemale = [], genderMaleLen = 0, genderFemaleLen = 0;
    if(gender.hasOwnProperty('Male')) {
      currentDataMale = gender['Male'].filter(this.isSearched(searchKey));
      genderMaleLen = gender['Male'].length;
    }

    if(gender.hasOwnProperty('Female')) {
      currentDataFemale = gender['Female'].filter(this.isSearched(searchKey));
      genderFemaleLen = gender['Female'].length;
    }

    const indexOfLastMale = activePageMale * itemPerPage;
    const indexOfFirstMale = indexOfLastMale - itemPerPage;

    const indexOfLastFemale = activePageFemale * itemPerPage;
    const indexOfFirstFemale = indexOfLastFemale - itemPerPage;

    const rowLengthMale = currentDataMale.length;
    currentDataMale = currentDataMale.slice(indexOfFirstMale, indexOfLastMale);
    const totalPagesMale = Math.ceil(rowLengthMale / itemPerPage);

    const rowLengthFemale = currentDataFemale.length;
    currentDataFemale = currentDataFemale.slice(indexOfFirstFemale, indexOfLastFemale);
    const totalPagesFemale = Math.ceil(rowLengthFemale / itemPerPage);

    const studentsTableMale = currentDataMale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell collapsing>
          <Label color='red' horizontal onClick={()=>this.open(studentName, sectionStudent.sectionStudentId, sectionStudent.sectionId)}>
            Remove
          </Label>
          </Table.Cell>
        </Table.Row>
      );
    });

    const studentsTableFemale = currentDataFemale.map((sectionStudent, key )=> {
      const studentName = sectionStudent.student.lastName +', '+ sectionStudent.student.firstName;
      return (
        <Table.Row key={key} className='sections-table-row'>
          <Table.Cell>{studentName}</Table.Cell>
          <Table.Cell collapsing>
          <Label color='red' horizontal onClick={()=>this.open(studentName, sectionStudent.sectionStudentId, sectionStudent.sectionId)}>
            Remove
          </Label>
          </Table.Cell>
        </Table.Row>
      );
    });

    const headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => this.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    let confirmContent = `Are you sure you want to remove ${this.state.studentName} in this section?`;

    return (
      <div className='table-sections'>
        <Input
          icon='search'
          fluid
          value={searchKey}
          onChange={this.onSearchChange}
          className='section-students-search'
          placeholder='Search Students'
        />
        {
          data.length > 0 ?
          <Grid>
            <Grid.Column width={8}>
              <h4>Male</h4>
              <Table celled selectable sortable striped compact size='small'>
                <Table.Header>
                  <Table.Row>
                    {headers}
                  </Table.Row>
                </Table.Header>

                <Table.Body>{studentsTableMale}</Table.Body>
                  {
                    genderMaleLen > itemPerPage ?
                    <PaginationTable
                      onPageChange={this.handlePaginationChangeMale}
                      totalPages={totalPagesMale}
                      activePage={activePageMale}
                      fields={fields}
                    >

                    </PaginationTable>
                    :
                    null
                  }
              </Table>
            </Grid.Column>
            <Grid.Column width={8}>
              <h4>Female</h4>
              <Table celled selectable sortable striped compact size='small'>
                <Table.Header>
                  <Table.Row>
                    {headers}
                  </Table.Row>
                </Table.Header>

                <Table.Body>{studentsTableFemale}</Table.Body>
                  {
                    genderFemaleLen > itemPerPage ?
                    <PaginationTable
                      onPageChange={this.handlePaginationChangeFemale}
                      totalPages={totalPagesFemale}
                      activePage={activePageFemale}
                      fields={fields}
                    >

                    </PaginationTable>
                    :
                    null
                  }
              </Table>
            </Grid.Column>
          </Grid>
          :
          <Segment>No student records found.</Segment>
        }
        <Confirm content={confirmContent} open={this.state.open} onCancel={this.close} onConfirm={this.handleDelete} />
      </div>
    )
  }
};

export default SectionStudents;
